// extracted by mini-css-extract-plugin
export default {"Pages":"pages_Pages__FCACv","Page":"pages_Page__O70ZH","trigger":"pages_trigger__WTP7J","EchoPage":"pages_EchoPage__tyLUH","Auth":"pages_Auth__o4k-w"};